import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';

export const styledBackstageHeaderIconLinkRow = (
  theme: Theme,
): BackstageOverrides['BackstageHeaderIconLinkRow'] => ({
  links: {
    alignItems: 'start',
    gap: theme.spacing(3),
    gridAutoColumns: 'max-content',
    maxWidth: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    paddingBottom: theme.spacing(0.5),
    scrollbarWidth: 'none',
    wordBreak: 'normal',
    WebkitOverflowScrolling: 'touch',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
});
